/**
 * GraphQL queries and subscriptions for UserRole
 */

export const LIST_USER_ROLES = /* GraphQL */ `
    query ListUserRoles($limit: Int, $nextToken: String) {
        listUserRoles(limit: $limit, nextToken: $nextToken) {
            items {
                id
                ownerId
                userId
                roleId
                workspaceId
                createdAt
                createdBy
            }
            nextToken
        }
    }
`;

export const onCreateUserRole = /* GraphQL */ `
    subscription OnCreateUserRole($ownerId: String) {
        onCreateUserRole(ownerId: $ownerId) {
            id
            ownerId
            userId
            roleId
            workspaceId
            createdAt
            createdBy
        }
    }
`;

export const onUpdateUserRole = /* GraphQL */ `
    subscription OnUpdateUserRole($ownerId: String) {
        onUpdateUserRole(ownerId: $ownerId) {
            id
            ownerId
            userId
            roleId
            workspaceId
            createdAt
            createdBy
        }
    }
`;

export const onDeleteUserRole = /* GraphQL */ `
    subscription OnDeleteUserRole($ownerId: String) {
        onDeleteUserRole(ownerId: $ownerId) {
            id
            ownerId
            userId
            roleId
            workspaceId
            createdAt
            createdBy
        }
    }
`;
